import { useQuery } from 'react-query';
import { queryForgotPasswordData } from './useForgotPasswordData.query';
import {
  UseForgotPasswordDataOptions,
  UseForgotPasswordDataParams,
  UseForgotPasswordDataResponse,
} from './useForgotPasswordData.types';

export const FORGOT_PASSWORD_DATA_QUERY_KEY = 'FORGOT_PASSWORD_DATA';

export const useForgotPasswordData = (
  params: UseForgotPasswordDataParams,
  options?: UseForgotPasswordDataOptions
) => {
  return useQuery<UseForgotPasswordDataResponse, Error>(
    [FORGOT_PASSWORD_DATA_QUERY_KEY, params.hash],
    () => queryForgotPasswordData(params),
    {
      ...options,
      retry: false,
      refetchOnWindowFocus: false,
      enabled: Boolean(params.hash),
    }
  );
};
